"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterSocialLink_1 = __importDefault(require("./FooterSocialLink"));
exports.default = FooterSocialLink_1.default;
